export default "__VITE_ASSET__8Sn8dURm__"